import { Button } from "@mixitone/components";
import { ApplicationView, useController } from "@mixitone/mvc";
import { FormController } from "./FormController";

interface FormButtonsProps {
  showDelete?: boolean;
  showCancel?: boolean;
  deleteTitle?: string;
  saveTitle?: string;
  disabled?: boolean;
}

const FormButtons: React.FC<FormButtonsProps> = ({
  showCancel,
  showDelete = true,
  deleteTitle,
  saveTitle,
  disabled = false,
}) => {
  const controller = useController(FormController);
  const { canDelete } = controller;
  const { saving } = controller.state;

  return (
    <div className="flex items-center justify-end gap-2">
      {showDelete && canDelete && (
        <Button
          type="button"
          kind="danger"
          disabled={disabled || saving}
          onClick={() => controller.actionDelete()}
        >
          {deleteTitle || "Delete"}
        </Button>
      )}
      <Button type="submit" disabled={disabled || saving} spinner={saving}>
        {saveTitle ? saveTitle : controller.state.newRecord ? "Create" : "Save"}
      </Button>
      {showCancel && (
        <Button disabled={saving} onClick={() => controller.actionCancel()}>
          Cancel
        </Button>
      )}
    </div>
  );
};

export default ApplicationView(FormButtons);
